module.exports = __webpack_public_path__ + "img/curtain_horizontal_50.31e76e80.svg";